<template>
   <div class="dvItem">
      <item class="item">
         <div class="dvImg">
            <img src="../assets/fabrica/blue-marine-1.png" />
         </div>
         <div class="dvCard">
            <div class="dvCardTitle">
               <span>Oficina <span>Opus - A</span></span>
               <span>Desde: $4,000.00</span>
            </div>
            <div class="dvCardInfo">
               <div>
                  <i class="fas fa-microchip"></i>
                  <div>
                     <span>Procesador</span>
                     <span>Intel i9 8400</span>
                  </div>
               </div>
               <div>
                  <i class="fas fa-memory"></i>
                  <div>
                     <span>Memoria Ram</span>
                     <span>16GB DDR4</span>
                  </div>
               </div>
               <div>
                  <i class="fas fa-paint-brush"></i>
                  <div>
                     <span>Gráficos</span>
                     <span>RTX 2070 8 GB</span>
                  </div>
               </div>
               <div>
                  <i class="fas fa-hdd"></i>
                  <div>
                     <span>Almacenamiento</span>
                     <span>1 TB</span>
                  </div>
               </div>
            </div>
         </div>
      </item>
   </div>
</template>

<script>
   export default {
      name: "Card"
   }
</script>

<style scoped lang="scss">
   @import "../style/base";

   .item {
   @include flexColumn;
      color: #ffffff;
      /*background: #f6d54b;*/
      min-width: 200px;
      max-width: 350px;
      margin: 10px 10px 70px;
      box-shadow: 0px 0px 10px -2px #f6d54b;

   &:HOVER {
       box-shadow: 0px 0px 10px 2px #f6d54b;
    }

   & .dvImg {
        position: relative;
        height: 100px;
   & > img {
        position: absolute;
        height: 150px;
        left: 30%;
        top: -55px;
     }
   }


   & .dvCard {
     @include flexColumn;
   & > div {
   &.dvCardTitle {
    @include flexColumn;
       justify-content: center;
       align-items: center;

   & > span {
        line-height: 1.2;
   &:first-of-type {
    @include fontFormat(18px, 700, #ffffff )
    }
   &:last-of-type {
    @include fontFormat(16px, 500, #ffffff )
    }
   }
   }

   &.dvCardInfo {
    @include flexRow;
       flex-wrap: wrap;
       justify-content: space-evenly;

   & > div {
     @include flexRow;
        align-items: center;
        padding: 5px;
        width: 175px;


   & i {
        font-size: 20px;
        padding: 10px;
        width: 45px;
     }

   & > div {
     @include flexColumn;
     }
   }
   }
   }
   }
   }
</style>